import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {TableRow, TableCell, Table, TableHead, TableBody, CardHeader, CardContent, Box, TextField } from '@material-ui/core';

// Shared components
import PortletFooter from 'components/PortletFooter';

// Component styles
import styles from './styles';
import { Grid } from '@material-ui/core';
import {api_host} from '../../../../common/globals/constants';
import {getThresholdNotification} from '../../../../services/getThresholdNotification'
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';


const sendValues = (value, d, sno, snp, sng, h, snla, emn, emx, objetivo_id, token, notificacion, data, user, admin_id) => {
    let method = 'POST'
    if (value == 2){
        method = 'PATCH'
    }
    return new Promise(resolve => {
        setTimeout(() => {
            fetch(api_host+`/reporte/general/objetivos/${objetivo_id}/alertas/?token=${token}&start=${new Date().getTime()}`, {
                method: method, // or 'PUT'
                body: JSON.stringify({token: token, objetivo_id: objetivo_id, notificacion: notificacion, 
                                        d: d, sno: sno, snp: snp, sng: sng, h: h, snla: snla, emn: emn, 
                                        emx: emx, data: data, user: user, admin: admin_id}), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => {
                    if (response.status == 1) {
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                }
                );
        }, 100);
    });
};

class NotificationsObjective extends Component {

    constructor(props) {
        super(props);
        this.state = {
            props: props,
            settingsEl: null,
            value: this.props.value,
			updateDisabled: true,
			dataError: false,
            isLoading: true,
            listObjective: this.props.listObjective,
            horarios: sessionStorage.getItem('user_schedules'),
            destinatarios: sessionStorage.getItem('user_addressee'),
            alertobjectives: this.props.alertobjectives,
            min: 1,
            max: 10,
            checkedGlobal: false,
            checkedUptime: false,
            checkedParcial: false,
            checkedUmbral: false,
            limit: false,
            limitUpdate: false,
            objetivo_id: this.props.objective,
            horario: 0,
            open: false,
            isValid: false,
            minUpdate: 0,
            maxUpdate: 0,
            checkedGlobalUpdate: false,
            checkedUptimeUpdate: false,
            checkedParcialUpdate: false,
            checkedUmbralUpdate: false,
            destinatarioUpdate: 0,
            horarioUpdate: 0,
            valueTab: 0,
            data: {},
            valueAtmobilleModal:0,
            showAlertNotificationMinMax: false,
            showAlertNotificationDestinatario: false,
            showAlertNotificationChecked: false,
            isValidNotification: true,
            destinatario: 0,
            umbralError: false
        }
        this.translation = (this.props && this.props.t) ? this.props.t : (s => s);
    }

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState[field] = value;   
        newState["showAlertNotificationMinMax"] = false
        newState["isValidNotification"] = true
        if (field.includes("checked")){
            newState["showAlertNotificationChecked"] = false;
            newState["isValidNotification"] = true
        }
        if(field == "checkedUmbral" && value == true){
            newState["checkedParcial"] = true;
        }else if (field == "checkedUmbral" && value == false )
        {
            newState["checkedParcial"] = false;
        }
        if (field === "checkedGlobal" && !value && !this.state.checkedParcial) {
            newState["checkedUptime"] = false
        }
        if (field === "checkedParcial" && !value && !this.state.checkedGlobal) {
            newState["checkedUptime"] = false
        }

        if (field === "checkedGlobalUpdate" && !value && !this.state.checkedParcialUpdate) {
            newState["checkedUptimeUpdate"] = false
        }
        if (field === "checkedParcialUpdate" && !value && !this.state.checkedGlobalUpdate) {
            newState["checkedUptimeUpdate"] = false
        }
        if (field === "min" && value > this.state.max && this.state.limit == false){
            newState["showAlertNotificationMinMax"] = true
            newState["isValidNotification"] = false
        }
        if (field === "minUpdate" && value > this.state.maxUpdate && this.state.limitUpdate == false){
            newState["showAlertNotificationMinMax"] = true
            newState["isValidNotification"] = false
        }
        if (field === "max" && this.state.min > value && this.state.limit == false){
            newState["showAlertNotificationMinMax"] = true
            newState["isValidNotification"] = false
        }
        if (field === "maxUpdate" && this.state.minUpdate > value && this.state.limitUpdate == false){
            newState["showAlertNotificationMinMax"] = true
            newState["isValidNotification"] = false
        }
        if (field === "destinatario"){
            newState["showAlertNotificationDestinatario"] = false
            newState["isValidNotification"] = true
        }
        if (field === "limit" && this.state.min > this.state.max && this.state.limit == true){
            newState["showAlertNotificationMinMax"] = true
            newState["isValidNotification"] = false
        }
        if (field === "limitUpdate" && this.state.minUpdate > this.state.maxUpdate && this.state.limitUpdate == true){
            newState["showAlertNotificationMinMax"] = true
            newState["isValidNotification"] = false
        }
        this.setState(newState);
    };

    handleFieldChangeTab = (field, value, valueTab, i) => {
        const newState = { ...this.state };
        if (value <= 0) { 
            newState['umbralError'] = true
            newState['data'][valueTab].data[i].umbral = parseInt(value); 
            this.setState(newState);
        } else {
            var isInvalidUmbral = false
            var contInvalidUmbral = 0
            Object.keys(newState['data']).map((key) => {
                Object.keys(newState['data'][key].data).map((keyStep) => {
                    if (newState['data'][key].data[keyStep].umbral <= 0){
                        contInvalidUmbral = contInvalidUmbral + 1
                        isInvalidUmbral = true
                        if (valueTab == key && i == keyStep && contInvalidUmbral <= 1){
                            isInvalidUmbral = false
                            contInvalidUmbral = contInvalidUmbral - 1
                        }
                    }
                })
            })
            newState['umbralError'] = isInvalidUmbral
            newState['data'][valueTab].data[i].umbral = parseInt(value); 
            this.setState(newState);
        }
    };
    
    handleSaved = async (value) => {
        const { checkedGlobalUpdate, checkedUptimeUpdate, checkedParcialUpdate, checkedUmbralUpdate, 
            checkedGlobal, checkedUptime, checkedParcial, checkedUmbral } = this.state;
        if ( this.state.value == 1 && this.state.destinatario == 0){
            this.setState({
                isValidNotification: false,
                showAlertNotificationDestinatario: true
            });
        } else if (this.state.value == 1 && (checkedGlobal == false && checkedUptime == false && checkedParcial == false && checkedUmbral == false &&
            checkedGlobalUpdate == false && checkedUptimeUpdate == false && checkedParcialUpdate == false && checkedUmbralUpdate == false)){
            this.setState({
                isValidNotification: false,
                showAlertNotificationChecked: true
            });
        } else {
            let user = sessionStorage.getItem('user')
            let admin_id = sessionStorage.getItem('admin_id')
            let listDestinatarios = JSON.parse(this.state.destinatarios)
            let d = listDestinatarios[0].notificacion_destinatario_id
            let sno = null
            let snp = null
            let sng = null
            let h = null
            let snla = null
            let emn = null
            let emx = null
            let token = sessionStorage.getItem('key')
            let notificacion = null
            let data = null

            if (this.state.value == 1){
                if (this.state.destinatario){
                    d = this.state.destinatario
                }
                sno = this.state.checkedUptime
                snp = this.state.checkedParcial
                sng = this.state.checkedGlobal
                if (!snp && !sng) {
                    sno = false
                }
                h = this.state.horario
                snla = this.state.checkedUmbral
                emn = this.state.min
                emx = this.state.max 
                if (this.state.limit){
                    emx = 'null'
                }
                data = this.state.data
            } else if (this.state.value == 2){
                d = this.state.destinatarioUpdate
                sno = this.state.checkedUptimeUpdate
                snp = this.state.checkedParcialUpdate
                sng = this.state.checkedGlobalUpdate
                if (!snp && !sng) {
                    sno = false
                }
                h = this.state.horario
                snla = this.state.checkedUmbralUpdate
                emn = this.state.minUpdate
                emx = this.state.maxUpdate
                if (this.state.limitUpdate){
                    emx = 'null'
                }
                notificacion = this.props.alertobjectives.notificacion_id
                data = this.state.data
            }
            try {
                this.setState({ isLoading: true });
                //var ok = false
                var ok = await sendValues(this.state.value, d, sno, snp, sng, h, snla, emn, emx, this.state.objetivo_id, token, notificacion, data, user, admin_id);
                if (ok){
                    this.setState({
                        isLoading: false,
                        isValid: true,                   
                        open: true
                    });
                } else {
                    this.setState({
                        isLoading: false,
                        isValid: false,                   
                        open: true
                    });
                }

            } catch (error) {
                
                this.setState({
                    isLoading: false,
                    //serviceError: error,
                    isValid: false,
                    open: true
                });
            }
        }

		
    };
    
    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })
	};



    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value !== prevState.value) {
            return {
                value: nextProps.value,
                updateDisabled: true
            }
        }
    }
    componentDidUpdate(){
        //this.processData()
    }

    componentDidMount(){
        this.processData()
    }

    processData() {
        const {objetivo_id} = this.state;
        let token = sessionStorage.getItem('key')
        var getData = getThresholdNotification(objetivo_id, token) 
        getData.then( data =>  { 
            if(this.props.value == 2 && this.state.updateDisabled) {
                this.setState({
                    minUpdate: this.props.alertobjectives.envia_desde,
                    maxUpdate: this.props.alertobjectives.envia_hasta,
                    checkedGlobalUpdate: this.props.alertobjectives.alerta_global,
                    checkedUptimeUpdate: this.props.alertobjectives.alerta_uptime_ok,
                    checkedParcialUpdate: this.props.alertobjectives.alerta_parcial,
                    checkedUmbralUpdate: this.props.alertobjectives.alerta_sla,
                    destinatarioUpdate: this.props.alertobjectives.notificacion_destinatario.notificacion_destinatario_id,
                    horarioUpdate: this.props.alertobjectives.horario_id,
                    updateDisabled: false,
                    data: data,
                    isLoading: false
                })
                if (!this.props.alertobjectives.envia_hasta) {
                    this.setState({limitUpdate: true})
                }
            } else {
                this.setState({
                    data: data,
                    isLoading: false
                })
            }
            for (let i = 0; i < data.length; i++) {
                const valorServicio =data[i]['servicio_modal']
                const valorServicioId =valorServicio
                const valorServicioValidador =[55,255,256,257,258,270,271,272,1100]
                if(!valorServicioValidador.includes(valorServicioId)){
                    this.setState({
                        valueAtmobilleModal:1
                    })
                }
            }
        })

          
        
    }

    handleChange = (event, newValue) => {
        this.setState({
            valueTab: newValue,
            //updateDisabled: true,
            //: null
        });
    };

    preventPaste = (e) => {
        e.preventDefault();
        return false;
    }


    render() {
        const { classes, className, alertobjectives, ...rest } = this.props;
        const { value, listobjective, horarios, destinatarios, min, max, limit, limitUpdate, open, isValid, minUpdate,
            maxUpdate, checkedGlobalUpdate, checkedUptimeUpdate, checkedParcialUpdate, checkedUmbralUpdate, destinatarioUpdate,
            horarioUpdate, checkedGlobal, checkedUptime, checkedParcial, checkedUmbral, data, valueTab, isLoading, valueAtmobilleModal,
            showAlertNotificationMinMax, showAlertNotificationDestinatario, isValidNotification, showAlertNotificationChecked, umbralError } = this.state;
        const rootClassName = classNames(classes.root, className);
        let listHorarios = JSON.parse(horarios)
        let listDestinatarios = JSON.parse(destinatarios)
        const t = this.translation;
        if (!isLoading) {
            return (
            
                <>
                        {value == 1 ?
                            <CardContent>
                                <form className={classes.form}>
                                    <div className={classes.group}>
                                        <FormControl size='small' variant='outlined' fullWidth className={classes.textFieldSelect}>
                                            <InputLabel id="destinatario-label">
                                                {t('monitoring.tools-section.alerts-config.modal.add.form.addressee.label')}
                                            </InputLabel>
                                            <Select
                                                labelId='destinatario-label'
                                                onChange={event =>
                                                    this.handleFieldChange('destinatario', event.target.value)
                                                }
                                                value={this.state.destinatario}
                                                label={t('monitoring.tools-section.alerts-config.modal.add.form.addressee.label')}
                                                defaultValue={0}
                                            >
                                                {Object.keys(listDestinatarios).map((key) => (
                                                    <MenuItem value={listDestinatarios[key].notificacion_destinatario_id}>{listDestinatarios[key].destinatario+' - '+listDestinatarios[key].nombre}</MenuItem>

                                                ))}
                                            </Select>
                                        </FormControl>
                                        {showAlertNotificationDestinatario ? (
                                                <Box
                                                    style={{marginBottom: 20}}
                                                    sx={{ textAlign: "right" }}
                                                >
                                                    <small style={{ color: "red" }}>
                                                        {t('monitoring.tools-section.alerts-config.modal.add.form.addressee.error.no-selection')}
                                                    </small>
                                                </Box>
                                            ) : null}
                                        <FormControl size='small' variant='outlined' fullWidth className={classes.textFieldSelect}> 
                                            <InputLabel id='horairo-label'>
                                                {t('monitoring.tools-section.alerts-config.modal.add.form.addressee.schedule')}
                                            </InputLabel>
                                            <Select
                                                labelId='horario-label'
                                                onChange={event =>
                                                    this.handleFieldChange('horario', event.target.value)
                                                }
                                                value={this.state.horario}
                                                label={t('monitoring.tools-section.alerts-config.modal.add.form.addressee.schedule')}
                                                defaultValue={0}
                                            >
                                                {Object.keys(listHorarios).map((key) => (
                                                    <MenuItem value={listHorarios[key].horario_id}>{listHorarios[key].nombre}</MenuItem>

                                                ))}
                                        
                                            </Select>
                                        </FormControl>
                                        <Divider className={classes.profileDivider} />
                                        <div>
                                            <Typography variant='body2'>
                                                {t('monitoring.tools-section.alerts-config.modal.add.form.text.title.scalability')}
                                            </Typography>
                                            <Typography style={{fontSize:'12px'}} variant="caption">{t('monitoring.tools-section.alerts-config.modal.add.form.text.description.scalability')}</Typography>
                                        </div>  
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                xl={3}>                      
                                                <div className={classes.field}>     
                                                    <Typography style={{marginRight:'5px'}} variant="body1">{t('text.from')}</Typography>
                                                    <input id="min" min="1" max="9999999999" type="number" value={ min } 
                                                        onChange={event =>this.handleFieldChange('min', event.target.value)}
                                                        onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨"].includes(e.key) && e.preventDefault()}
                                                        onPaste={this.preventPaste}/>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                xl={3}>   
                                                <div className={classes.field}> 
                                                    <Typography style={{marginRight:'5px'}} variant="body1">{t('text.to')}</Typography>
                                                    <input id="max" min="1" max="9999999999" type="number" value={max} 
                                                        onChange={event =>this.handleFieldChange('max', event.target.value)} disabled={limit}
                                                        onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨"].includes(e.key) && e.preventDefault()}
                                                        onPaste={this.preventPaste}/>  
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                xl={2}> 
                                                <div className={classes.field2}>  
                                                        <Checkbox
                                                            color="primary"
                                                            //defaultChecked
                                                            checked={limit}
                                                            onChange={event =>this.handleFieldChange('limit', event.target.checked)}
                                                        />   
                                                    <Typography variant="body1">{t('monitoring.tools-section.alerts-config.modal.add.form.text.description.no-limit')}</Typography> 
                                                </div> 
                                            </Grid>
                                            {showAlertNotificationMinMax ? (
                                                <Box
                                                    style={{marginBottom: 20}}
                                                    sx={{ textAlign: "right" }}
                                                >
                                                    <small style={{ color: "red" }}>
                                                        {t('monitoring.tools-section.alerts-config.modal.add.form.button.add-alert')}
                                                    </small>
                                                </Box>
                                            ) : null}
                                        </Grid>
                                        <Divider className={classes.profileDivider} />
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>                                         
                                                <div className={classes.field}>
                                                    <Checkbox 
                                                        color="primary" 
                                                        checked={checkedGlobal}
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedGlobal', event.target.checked)
                                                        }
                                                        />
                                                    <div>
                                                        <Typography variant="body1">{t('monitoring.tools-section.alerts-config.modal.add.form.check.option.global-alert.label')}</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'12px'}} variant="caption">
                                                            {t('monitoring.tools-section.alerts-config.modal.add.form.check.option.global-alert.description')}
                                                        </Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>  
                                                <div className={classes.field}>
                                                    <Checkbox
                                                        color="primary"
                                                        checked={checkedParcial}
                                                        //defaultChecked
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedParcial', event.target.checked)
                                                        }
                                                    />
                                                    <div>
                                                        <Typography variant="body1">{t('monitoring.tools-section.alerts-config.modal.add.form.check.option.partial-alert.label')}</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'12px'}} variant="caption">
                                                            {t('monitoring.tools-section.alerts-config.modal.add.form.check.option.partial-alert.description')}
                                                        </Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>
                                                <div className={classes.field}>
                                                    <Checkbox
                                                        color="primary"
                                                        checked={checkedUptime}
                                                        //defaultChecked
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedUptime', event.target.checked)
                                                        }
                                                        disabled={!checkedParcial && !checkedGlobal}
                                                    />
                                                    <div>
                                                        <Typography variant="body1">{t('monitoring.tools-section.alerts-config.modal.add.form.check.option.uptime-alert.label')}</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'12px'}} variant="caption">
                                                            {t('monitoring.tools-section.alerts-config.modal.add.form.check.option.uptime-alert.description')}
                                                        </Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        {valueAtmobilleModal == 0 ?
                                            <Grid
                                                container
                                                spacing={0}>
                                                <Grid
                                                    item
                                                    xs={3}
                                                    sm={3}
                                                    md={3}
                                                    xl={3}>
                                                    <div className={classes.field}>
                                                        <Checkbox
                                                            color="primary"
                                                            //defaultChecked
                                                            checked={checkedUmbral}
                                                            onChange={event =>
                                                                this.handleFieldChange('checkedUmbral', event.target.checked)
                                                            }
                                                        />
                                                        <div>
                                                            <Typography variant="body1">{t('monitoring.tools-section.alerts-config.modal.add.form.check.option.threshold-alert.label')}</Typography>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={9}
                                                    sm={9}
                                                    md={9}
                                                    xl={9}>
                                                        <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                            <Typography style={{fontSize:'12px'}} variant="caption">
                                                                 {t('monitoring.tools-section.alerts-config.modal.add.form.check.option.threshold-alert.description')}
                                                            </Typography>
                                                        </div>
                                                </Grid>
                                            </Grid>
                                        :null}
                                        {checkedUmbral ?
                                            <div className={classes.root}>
                                                <Divider className={classes.profileDivider} />
                                                <AppBar position="static">
                                                    <Tabs scrollButtons="auto" value={valueTab} onChange={this.handleChange} aria-label="simple tabs example">
                                                        {data.map((key) => (
                                                            <Tab label={key.monitor.nombre_nodo}  />
                                                        ))}
                                                    </Tabs>
                                                </AppBar>
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell></TableCell>
                                                            <TableCell>Nombre</TableCell>
                                                            <TableCell>Umbral</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data[valueTab].pasos.map((key, i) => (
                                                            <TableRow>
                                                                <TableCell>{key.orden}</TableCell>
                                                                <TableCell>{key.nombre}</TableCell>
                                                                <TableCell><TextField id="umbral" type="number" variant="outlined" size="small" required
                                                                    InputProps={{inputProps: {min: 1,},}}
                                                                    //error={umbralError} helperText={umbralError ? 'El valor no puede ser menor a 1' : ''}
                                                                    defaultValue={data[valueTab].data[i] !== undefined ? data[valueTab].data[i].umbral : 1}                                                                     
                                                                    onChange={event =>this.handleFieldChangeTab('umbral', event.target.value, valueTab, i)}
                                                                    onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨"].includes(e.key) && e.preventDefault()}
                                                                    onPaste={this.preventPaste}/> 
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                {umbralError ? (
                                                        <Box
                                                            style={{marginBottom: 20}}
                                                            sx={{ textAlign: "right" }}
                                                        >
                                                            <small style={{ color: "red" }}>
                                                                {t('monitoring.tools-section.alerts-config.modal.add.table.threshold.error')}
                                                            </small>
                                                        </Box>
                                                    ) : null}
                                            </div>
                                        :null}
                                        {showAlertNotificationChecked ? (
                                                <Box
                                                    style={{marginBottom: 20}}
                                                    sx={{ textAlign: "right" }}
                                                >
                                                    <small style={{ color: "red" }}>
                                                        {t('monitoring.tools-section.alerts-config.modal.add.form.check.option.threshold-alert.error.no-selection')}
                                                    </small>
                                                </Box>
                                            ) : null}
                                    </div>
                                </form>
                            </CardContent>
                            /*Seccion Update*/
                        :   <CardContent>
                                <form className={classes.form}>
                                    <div className={classes.group}>
                                        <FormControl size='small' variant='outlined' fullWidth className={classes.textFieldSelect}>
                                            <InputLabel id="destinatario-update-label">
                                                {t('monitoring.tools-section.alerts-config.modal.update.form.addressee.label')}
                                            </InputLabel>
                                            <Select
                                                labelId='destinatario-update-label'
                                                onChange={event =>
                                                    this.handleFieldChange('destinatarioUpdate', event.target.value)
                                                }
                                                value={this.state.destinatarioUpdate}
                                                label={t('monitoring.tools-section.alerts-config.modal.update.form.addressee.label')}
                                                defaultValue={0}
                                            >
                                                {Object.keys(listDestinatarios).map((key) => (
                                                    <MenuItem value={listDestinatarios[key].notificacion_destinatario_id}>{listDestinatarios[key].destinatario+' - '+listDestinatarios[key].nombre}</MenuItem>

                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl size='small' variant='outlined' fullWidth className={classes.textFieldSelect}> 
                                            <InputLabel id='horairo-update-label'>
                                                {t('monitoring.tools-section.alerts-config.modal.update.form.addressee.schedule')}
                                            </InputLabel>
                                            <Select
                                                labelId='horario-update-label'
                                                onChange={event =>
                                                    this.handleFieldChange('horarioUpdate', event.target.value)
                                                }
                                                value={this.state.horario}
                                                label={t('monitoring.tools-section.alerts-config.modal.update.form.addressee.schedule')}
                                                defaultValue={0}
                                            >
                                                {Object.keys(listHorarios).map((key) => (
                                                    <MenuItem value={listHorarios[key].horario_id}>{listHorarios[key].nombre}</MenuItem>

                                                ))}
                                        
                                            </Select>
                                        </FormControl>
                                        <Divider className={classes.profileDivider} />
                                        <div>
                                            <Typography variant='body2'>
                                                {t('monitoring.tools-section.alerts-config.modal.update.form.text.title.scalability')}
                                            </Typography>
                                            <Typography style={{fontSize:'12px'}} variant="caption">{t('monitoring.tools-section.alerts-config.modal.update.form.text.description.scalability')}</Typography>
                                        </div>   
                                        <Grid
                                            container
                                            spacing={0}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                xl={3}>
                                                <div className={classes.field}>
                                                    <Typography style={{marginRight:'5px'}} variant="body1">{t('text.from')}</Typography>
                                                    <input id="minUpdate" min="1" max="9999999999" type="number" value={ minUpdate }
                                                        onChange={event =>this.handleFieldChange('minUpdate', event.target.value)}
                                                        onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨"].includes(e.key) && e.preventDefault()}
                                                        onPaste={this.preventPaste}/>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                xl={3}>   
                                                    <div className={classes.field}>
                                                        <Typography style={{marginRight:'5px'}} variant="body1">{t('text.to')}</Typography>
                                                        <input id="maxUpdate" min="1" max="9999999999" type="number" value={ maxUpdate } 
                                                            onChange={event =>this.handleFieldChange('maxUpdate', event.target.value)} disabled={limitUpdate}
                                                            onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨"].includes(e.key) && e.preventDefault()}
                                                            onPaste={this.preventPaste}/>                                    
                                                            
                                                    </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                xl={2}> 
                                                    <div className={classes.field2}>  
                                                        <Checkbox
                                                            color="primary"
                                                            //defaultChecked
                                                            checked={limitUpdate}
                                                            onChange={event =>this.handleFieldChange('limitUpdate', event.target.checked)}
                                                        />   
                                                        <Typography variant="body1">{t('monitoring.tools-section.alerts-config.modal.update.form.text.description.no-limit')}</Typography> 
                                                    </div> 
                                            </Grid>
                                            {showAlertNotificationMinMax ? (
                                                <Box
                                                    style={{marginBottom: 20}}
                                                    sx={{ textAlign: "right" }}
                                                >
                                                    <small style={{ color: "red" }}>
                                                        {t('monitoring.tools-section.alerts-config.modal.update.form.button.update-alert')}
                                                    </small>
                                                </Box>
                                            ) : null}
                                        </Grid> 
                                        <Divider className={classes.profileDivider} />
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>                                         
                                                <div className={classes.field}>
                                                    <Checkbox 
                                                        color="primary" 
                                                        checked={checkedGlobalUpdate}
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedGlobalUpdate', event.target.checked)
                                                        }
                                                        />
                                                    <div>
                                                        <Typography variant="body1">{t('monitoring.tools-section.alerts-config.modal.update.form.check.option.global-alert.label')}</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'12px'}} variant="caption">
                                                            {t('monitoring.tools-section.alerts-config.modal.update.form.check.option.global-alert.description')}
                                                        </Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>  
                                                <div className={classes.field}>
                                                    <Checkbox
                                                        color="primary"
                                                        checked={checkedParcialUpdate}
                                                        //defaultChecked
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedParcialUpdate', event.target.checked)
                                                        }
                                                    />
                                                    <div>
                                                        <Typography variant="body1">{t('monitoring.tools-section.alerts-config.modal.update.form.check.option.partial-alert.label')}</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'12px'}} variant="caption">
                                                            {t('monitoring.tools-section.alerts-config.modal.update.form.check.option.partial-alert.description')}
                                                        </Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>
                                                <div className={classes.field}>
                                                    <Checkbox
                                                        color="primary"
                                                        checked={checkedUptimeUpdate}
                                                        //defaultChecked
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedUptimeUpdate', event.target.checked)
                                                        }
                                                        disabled={!checkedParcialUpdate && !checkedGlobalUpdate}
                                                    />
                                                    <div>
                                                        <Typography variant="body1">{t('monitoring.tools-section.alerts-config.modal.update.form.check.option.uptime-alert.label')}</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'12px'}} variant="caption">
                                                            {t('monitoring.tools-section.alerts-config.modal.update.form.check.option.uptime-alert.description')}
                                                        </Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>   
                                                <div className={classes.field}>
                                                    <Checkbox
                                                        color="primary"
                                                        //defaultChecked
                                                        checked={checkedUmbralUpdate}
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedUmbralUpdate', event.target.checked)
                                                        }
                                                    />
                                                    <div>
                                                        <Typography variant="body1">{t('monitoring.tools-section.alerts-config.modal.update.form.check.option.threshold-alert.label')}</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'12px'}} variant="caption">
                                                            {t('monitoring.tools-section.alerts-config.modal.update.form.check.option.threshold-alert.description')}
                                                        </Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        
                                        {checkedUmbralUpdate ?
                                            <div className={classes.root}>
                                                <Divider className={classes.profileDivider} />
                                                <AppBar position="static">
                                                    <Tabs scrollButtons="auto" value={valueTab} onChange={this.handleChange} aria-label="simple tabs example">
                                                        {data.map((key) => (
                                                            <Tab label={key.monitor.nombre_nodo}  />
                                                        ))}
                                                    </Tabs>
                                                </AppBar>
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell></TableCell>
                                                            <TableCell>{t('monitoring.tools-section.alerts-config.modal.update.table.name')}</TableCell>
                                                            <TableCell>{t('monitoring.tools-section.alerts-config.modal.update.table.threshold')}</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data[valueTab].pasos.map((key, i) => (
                                                            <TableRow>
                                                                <TableCell>{key.orden}</TableCell>
                                                                <TableCell>{key.nombre}</TableCell>
                                                                <TableCell>
                                                                    <input id="umbralUpdate" min="1" max="9999999999" type="number" 
                                                                    //error={umbralError} helperText={umbralError ? 'El valor no puede ser menor a 1' : ''}
                                                                    value={data[valueTab].data[i] !== undefined ? data[valueTab].data[i].umbral : 1} 
                                                                    onChange={event =>this.handleFieldChangeTab('umbralUpdate', event.target.value, valueTab, i)}
                                                                    onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨"].includes(e.key) && e.preventDefault()}
                                                                    onPaste={this.preventPaste}/> 
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                {umbralError ? (
                                                        <Box
                                                            style={{marginBottom: 20}}
                                                            sx={{ textAlign: "right" }}
                                                        >
                                                            <small style={{ color: "red" }}>
                                                                {t('monitoring.tools-section.alerts-config.modal.update.form.checkbox.umbral-alert.error')}
                                                            </small>
                                                        </Box>
                                                    ) : null}
                                            </div>
                                        :null}
                                    </div>
                                </form>
                            </CardContent>}
                            <Snackbar
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                    open={open}
                                    autoHideDuration={6000}
                                    onClose={this.handleClose}
                                >
                                    <SnackbarContent
                                        className={isValid ? classes.snackContentOk
                                                    : classes.snackContent}
                                        aria-describedby="client-snackbar"
                                        message={
                                            
                                                isValid ?
                                                    <span id="client-snackbar" className={classes.message}>
                                                        <CheckCircleIcon className={(classes.icon, classes.iconVariant)}/>
                                                        {t('monitoring.tools-section.alerts-config.modal.update.form.check.option.threshold-alert.success')}
                                                    </span>
                                                :	<span id="client-snackbar" className={classes.message}>
                                                        <ErrorIcon className={(classes.icon, classes.iconVariant)}/>
                                                        {t('monitoring.tools-section.alerts-config.modal.update.form.check.option.threshold-alert.error')}
                                                    </span>
                                            
                                        }
                                        action={[
                                            <IconButton key="close" aria-label="close" color="inherit" onClick={this.handleClose}>
                                                <CloseIcon className={classes.icon}/>
                                            </IconButton>
                                        ]}
                                    />
                            </Snackbar>
                        <PortletFooter className={classes.portletFooter} align="right">
                            <Button
                                color="primary"
                                variant='contained'
                                onClick={this.handleSaved}
                                disabled={!isValidNotification || umbralError}
                            >
                                {t('text.save')}
                            </Button>
                        </PortletFooter>
                </>
            );
        } else  {
            return( 
                <AtCircularProgress />
            )
        }
        
    }
}

NotificationsObjective.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

export default compose(withStyles(styles), withTranslation())(NotificationsObjective);
